export const PRODUCT_UPDATE_LIBRARY = 'PRODUCT_UPDATE_LIBRARY';
export const PRODUCT_UPDATE_INSTANTLY_CREATED =
  'PRODUCT_UPDATE_INSTANTLY_CREATED';
export const PRODUCT_REMOVE_INSTANTLY_CREATED =
  'PRODUCT_REMOVE_INSTANTLY_CREATED';
